<template>
  <BaseNavbar
    v-bind="props"
    :show-logo="!showBackButton"
    :back-props="{
      class: 'min-md:gap-1.5 min-md:text-sm h-14 min-w-10 border-0 p-0 font-normal md:flex',
      ...props.backProps,
    }"
    :classes="{
      root: cn('border-b-0', props.class, props.classes?.root),
      ...props.classes,
    }"
    @exit="emit('exit')"
  >
    <template v-if="!isMobile" #backIcon>
      <ClientOnly>
        <LucideArrowRight :size="14" />
        {{ t("back_to_portfolio") }}
      </ClientOnly>
    </template>

    <slot />
  </BaseNavbar>
</template>

<script setup lang="ts">
import { LucideArrowRight } from "lucide-vue-next"

import type { KycBaseNavbarProps } from "@finq/kyc/components/base/Navbar.vue"

interface PensionPortfolioNavbarProps extends KycBaseNavbarProps {
  class?: ClassValue
}

const props = withDefaults(defineProps<PensionPortfolioNavbarProps>(), {
  showBackButton: true,
  showExitButton: true,
  isSticky: false,
})

const { isMobile } = useDisplay()

const emit = defineEmits<{
  (e: "exit"): void
}>()

const { t } = useI18n({ useScope: "local" })
</script>

<i18n lang="json">
{
  "he": {
    "back_to_portfolio": "לתיק שלי"
  },
  "en": {
    "back_to_portfolio": "Back to portfolio"
  }
}
</i18n>
